(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-common-contaminants"] && !Shopify.designMode) return;
  try {
    
  class CfContaminantsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;

      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      if (!this.slides.length) return;

      this.bullets = Array.from(this.querySelectorAll('[data-carousel-pagination] > *'));
      this.counter = this.querySelector('[data-carousel-current]');
      this.arrows = Array.from(this.querySelectorAll('[data-carousel-prev], [data-carousel-next]'));

      this.index = 0;
      this.cloneCount = 0;
      this.measuredPerView = 0;

      this.querySelectorAll('[data-carousel-prev]').forEach((button) => {
        button.addEventListener('click', () => this.step(-1));
      });

      this.querySelectorAll('[data-carousel-next]').forEach((button) => {
        button.addEventListener('click', () => this.step(1));
      });

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.buildClones();

      // perView changes with the viewport, and so does how many clones are needed
      this.resizeObserver = new ResizeObserver(() => this.buildClones());
      this.resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      clearTimeout(this.settleTimer);
    }

    /** Width of one slide plus the gap between slides. */
    get stride() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return this.slides[0].offsetWidth + gap;
    }

    /** How many slides are visible at once. */
    get perView() {
      const stride = this.stride;
      return stride ? Math.max(1, Math.round(this.track.clientWidth / stride)) : 1;
    }

    /** Nothing to loop through when every slide already fits. */
    get loops() {
      return this.slides.length > this.perView;
    }

    /**
     * Swiper's loop works by cloning the leading and trailing slides so the track can keep
     * scrolling past either end. Without clones only slides.length - perView scroll positions
     * exist, so with 8 slides at 4 per view the last three bullets can never activate.
     * Rebuilt whenever perView changes, since the number of clones depends on it.
     */
    buildClones() {
      const perView = this.perView;
      if (perView === this.measuredPerView) return;
      this.measuredPerView = perView;

      this.track.querySelectorAll('[data-carousel-clone]').forEach((node) => node.remove());

      this.cloneCount = this.loops ? Math.min(perView, this.slides.length) : 0;

      if (this.cloneCount) {
        const trailing = this.slides.slice(-this.cloneCount);
        // prepend in reverse so the trailing slides keep their order at the head
        for (let i = trailing.length - 1; i >= 0; i -= 1) {
          this.track.prepend(this.cloneSlide(trailing[i]));
        }
        this.slides.slice(0, this.cloneCount).forEach((slide) => {
          this.track.append(this.cloneSlide(slide));
        });
      }

      this.arrows.forEach((button) => {
        button.disabled = !this.loops;
      });

      this.scrollToSlot(this.index + this.cloneCount, false);
      this.render();
    }

    /** Clones are decorative duplicates — keep them out of the tab order and off screen readers. */
    cloneSlide(slide) {
      const clone = slide.cloneNode(true);
      clone.setAttribute('data-carousel-clone', '');
      clone.removeAttribute('data-carousel-slide');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      return clone;
    }

    /** Slots are DOM positions, so they include the prepended clones. */
    scrollToSlot(slot, smooth) {
      this.track.scrollTo({ left: slot * this.stride, behavior: smooth ? 'smooth' : 'auto' });
    }

    step(direction) {
      if (!this.loops) return;
      const total = this.slides.length;
      const target = this.index + direction;

      // At either end this scrolls into a clone; normalize() hops back once it settles
      this.scrollToSlot(target + this.cloneCount, true);
      this.index = ((target % total) + total) % total;
      this.render();
    }

    onScroll() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.sync());

      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.normalize(), 140);
    }

    sync() {
      const stride = this.stride;
      if (!stride) return;
      const total = this.slides.length;
      const slot = Math.round(this.track.scrollLeft / stride);
      this.index = (((slot - this.cloneCount) % total) + total) % total;
      this.render();
    }

    /** Once scrolling settles on a clone, jump to the matching real slide without animating. */
    normalize() {
      if (!this.cloneCount) return;
      const stride = this.stride;
      if (!stride) return;

      const total = this.slides.length;
      const slot = Math.round(this.track.scrollLeft / stride);
      if (slot >= this.cloneCount && slot < this.cloneCount + total) return;

      const inherited = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.scrollToSlot(slot < this.cloneCount ? slot + total : slot - total, false);
      requestAnimationFrame(() => {
        this.track.style.scrollBehavior = inherited;
      });
    }

    render() {
      this.bullets.forEach((bullet, i) => {
        bullet.classList.toggle('is-active', i === this.index);
      });
      if (this.counter) this.counter.textContent = String(this.index + 1);
    }
  }

  if (!customElements.get('cf-contaminants-carousel')) {
    customElements.define('cf-contaminants-carousel', CfContaminantsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-featured-products"] && !Shopify.designMode) return;
  try {
    
  /**
   * Hovering or clicking a colour swatch selects that colour, mirroring the Pack
   * ColorVariantOption's onMouseEnter/onClick: the swatch becomes active and the card's
   * image, links and price follow the first variant of that colour.
   */
  class CfProductCard extends HTMLElement {
    connectedCallback() {
      this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
      if (!this.swatches.length) return;

      this.image = this.querySelector('[data-card-image]');
      this.links = Array.from(this.querySelectorAll('[data-card-link]'));
      this.price = this.querySelector('[data-card-price]');
      this.compare = this.querySelector('[data-card-compare]');

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('mouseenter', () => this.select(swatch));
        swatch.addEventListener('focus', () => this.select(swatch));
        swatch.addEventListener('click', () => this.select(swatch));
      });
    }

    /** @param {HTMLElement} swatch */
    select(swatch) {
      if (this.selected === swatch) return;
      this.selected = swatch;

      this.swatches.forEach((item) => {
        item.classList.toggle('is-selected', item === swatch);
      });

      const { url, image, price, compare } = swatch.dataset;

      if (image && this.image) {
        // The srcset was built for the original image, so drop it before swapping the src
        this.image.removeAttribute('srcset');
        this.image.removeAttribute('sizes');
        this.image.src = image;
      }

      if (url) {
        this.links.forEach((link) => {
          link.href = url;
        });
      }

      if (price && this.price) this.price.textContent = price;

      if (this.compare) {
        this.compare.textContent = compare || '';
        this.compare.hidden = !compare;
      }
    }
  }

  if (!customElements.get('cf-product-card')) {
    customElements.define('cf-product-card', CfProductCard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-contact-form-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pack-contact-form-builder').forEach(function (section) {
    // Mobile accordion: toggle aria-expanded and hidden on body element
    section.querySelectorAll('.pack-contact-form-builder__item-title-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        var newExpanded = !isExpanded;
        btn.setAttribute('aria-expanded', String(newExpanded));
        var body = btn.parentElement.querySelector('.pack-contact-form-builder__item-body');
        if (body) {
          if (newExpanded) {
            body.removeAttribute('hidden');
          } else {
            body.setAttribute('hidden', '');
          }
        }
      });
    });

    // Gorgias embed: inject loader script into each embed container
    section.querySelectorAll('.pack-contact-form-builder__gorgias-embed[data-uid]').forEach(function (embed) {
      var uid = embed.getAttribute('data-uid');
      if (!uid) return;
      var script = document.createElement('script');
      script.src = 'https://contact.gorgias.help/api/contact-forms/loader.js?v=3';
      script.defer = true;
      script.setAttribute('data-gorgias-loader-contact-form', '');
      script.setAttribute('data-gorgias-contact-form-uid', uid);
      embed.appendChild(script);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-content-blocks"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // ── Reading progress bar ──────────────────────────────────────────
  // The bar is authored in this section but belongs under the header rows, which live in
  // the header section. On load we move it there, after the last .header__row.
  var fill = null;
  var barNode = null;

  function getHeaderComponent() {
    return document.querySelector('header-component');
  }

  function placeProgressBar() {
    var header = getHeaderComponent();
    var bars = Array.prototype.slice.call(document.querySelectorAll('.pack-content-blocks__progress'));

    // If the header was re-rendered out from under us, re-use the detached node we already have
    if (!bars.length && barNode) bars = [barNode];

    if (!bars.length) {
      fill = null;
      return;
    }

    // The freshly rendered bar is the one still sitting in this section's markup.
    // Anything left inside the header is from a previous render (theme editor reload).
    var current = bars.filter(function (el) {
      return !header || !header.contains(el);
    }).pop() || bars[bars.length - 1];

    bars.forEach(function (el) {
      if (el !== current) el.remove();
    });

    barNode = current;

    fill = current.querySelector('.pack-content-blocks__progress-fill');

    var rows = header ? header.querySelectorAll('.header__row') : null;
    var lastRow = rows && rows.length ? rows[rows.length - 1] : null;

    if (!lastRow) {
      // No header to attach to — keep the old fixed positioning below it
      current.classList.add('pack-content-blocks__progress--fixed');
      return;
    }

    current.classList.remove('pack-content-blocks__progress--fixed');
    if (current.previousElementSibling !== lastRow) {
      lastRow.insertAdjacentElement('afterend', current);
    }

    updateProgress();
  }

  var ticking = false;
  function updateProgress() {
    if (!fill) return;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    fill.style.width = (max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0) + '%';
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!fill || ticking) return;
    requestAnimationFrame(updateProgress);
    ticking = true;
  }, { passive: true });

  placeProgressBar();

  // Theme editor: re-place the bar when this section re-renders, and clean it out of the
  // header when the section is removed (the header itself is never re-rendered with it).
  document.addEventListener('shopify:section:load', placeProgressBar);
  document.addEventListener('shopify:section:unload', function () {
    if (document.querySelector('.pack-content-blocks')) return;
    var header = getHeaderComponent();
    if (header) {
      header.querySelectorAll('.pack-content-blocks__progress').forEach(function (el) {
        el.remove();
      });
    }
    barNode = null;
    fill = null;
  });

  // ── TOC toggle ───────────────────────────────────────────────────
  var tocToggle = document.querySelector('.pack-content-blocks__toc-toggle');
  var tocNav = document.getElementById('toc-nav');
  if (tocToggle && tocNav) {
    tocToggle.addEventListener('click', function () {
      var expanded = tocToggle.getAttribute('aria-expanded') === 'true';
      tocToggle.setAttribute('aria-expanded', String(!expanded));
      tocNav.hidden = expanded;
    });
  }

  // ── Mobile TOC dropdown ──────────────────────────────────────────
  var mobileBar = document.querySelector('.pack-content-blocks__toc-mobile');
  var mobileToggle = document.getElementById('pack-toc-mobile-toggle');
  var mobileMenu = document.getElementById('pack-toc-mobile-menu');

  function setMobileMenu(open) {
    if (!mobileToggle || !mobileMenu) return;
    mobileToggle.setAttribute('aria-expanded', String(open));
    mobileMenu.hidden = !open;
  }

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      setMobileMenu(mobileToggle.getAttribute('aria-expanded') !== 'true');
    });

    // Tap outside the dropdown closes it
    document.addEventListener('click', function (event) {
      if (mobileToggle.getAttribute('aria-expanded') !== 'true') return;
      if (mobileBar && mobileBar.contains(event.target)) return;
      setMobileMenu(false);
    });
  }

  // ── TOC smooth-scroll ────────────────────────────────────────────
  var tocItems = document.querySelectorAll('.pack-content-blocks__toc-item');
  function getHeaderHeight() {
    // --header-height is set on <body> by header.js and now includes the progress bar,
    // since the bar sits inside the header component
    var h = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10);
    return isNaN(h) ? 83 : h;
  }

  function getStickyOffset() {
    // On mobile the sticky TOC bar sits below the header and also covers content
    var offset = getHeaderHeight();
    if (mobileBar && mobileBar.offsetParent !== null) {
      offset += mobileToggle ? mobileToggle.offsetHeight : mobileBar.offsetHeight;
    }
    return offset;
  }

  tocItems.forEach(function (item) {
    item.addEventListener('click', function () {
      var anchor = item.getAttribute('data-anchor');
      if (!anchor) return;
      setMobileMenu(false);
      // Try the anchor div inside the text block first, then the block itself
      var target = document.getElementById('anchor-' + anchor) || document.getElementById(anchor);
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.scrollY - getStickyOffset();
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  // ── Active TOC item highlighting ─────────────────────────────────
  function updateActiveTocItem() {
    if (!tocItems.length) return;
    var offset = getStickyOffset();
    var scrollY = window.scrollY;
    var activeAnchor = null;

    var anchors = document.querySelectorAll('.pack-content-block-text__anchor, .pack-content-block-references__anchor, .pack-content-block-article-blockquote__anchor');
    anchors.forEach(function (el) {
      var parentId = el.parentElement ? el.parentElement.id : '';
      if (!parentId) return;
      var top = el.getBoundingClientRect().top + window.scrollY - offset - 8;
      if (scrollY >= top) {
        activeAnchor = parentId;
      }
    });

    tocItems.forEach(function (item) {
      var anchor = item.getAttribute('data-anchor');
      if (anchor === activeAnchor) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });
  }

  window.addEventListener('scroll', updateActiveTocItem, { passive: true });
  updateActiveTocItem();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-newsletter-extended"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initEmailForm(section) {
    var klaviyoKey = section.dataset.klaviyoKey;
    var listId = section.dataset.emailList;
    var form = section.querySelector('.pack-newsletter-extended__email-form');
    var successEl = section.querySelector('.pack-newsletter-extended__email-success');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.checkValidity()) return;
      if (!klaviyoKey) { console.warn('[newsletter-extended] Missing Klaviyo public key'); return; }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Website Newsletter Signup Form',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  subscriptions: {},
                  email: emailInput.value.trim()
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId || 'MQLkqr' } } }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoKey, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.status === 202 || res.status === 200) {
          form.setAttribute('hidden', '');
          if (successEl) successEl.removeAttribute('hidden');
        }
      }).catch(function (err) {
        console.error('[newsletter-extended] Email subscribe error:', err);
      });
    });
  }

  document.querySelectorAll('.pack-newsletter-extended').forEach(function (section) {
    if (section.dataset.formType === 'email') {
      initEmailForm(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
